export default [
  {
    path: '/roadwork/booking',
    meta: {
      title: '预约单',
    },
    component: () => import('@/views/roadwork/Booking.vue'),
  },
  {
    path: '/roadwork/workorder',
    meta: {
      title: '施工单管理',
    },
    component: () => import('@/views/roadwork/Workorder.vue'),
  },

  {
    path: '/roadwork/foreman-review',
    meta: {
      title: '工人入驻审核',
    },
    component: () => import('@/views/roadwork/foreman-review'),
  },
  {
    path: '/roadwork/worker',
    meta: {
      title: '工人管理',
    },
    component: () => import('@/views/roadwork/Worker.vue'),
  },
  {
    path: '/roadwork/cameras',
    meta: {
      title: '摄像头',
    },
    component: () => import('@/views/roadwork/cameras'),
  },
  {
    path: '/roadwork/qr-code',
    meta: {
      title: '二维码管理'
    },
    component: () => import('@/views/roadwork/qrcode/Batch.vue')
  },
  {
    path: '/roadwork/view-schedule',
    meta: {
      title: '查看日程'
    },
    component: () => import('@/views/roadwork/view-schedule.vue')

  },
  //-------------内页
  {
    path: '/roadwork/qr-code/list',
    meta: {
      title: '批次二维码列表',
    },
    component: () => import('@/views/roadwork/qrcode/QRCodeList'),
  },

  //----------其他

  {
    path: '/settlement-application',
    meta: {
      title: '结算申请'
    },
    component: () => import('@/views/roadwork/settlement-application')
  },
  {
    path: '/settlement-bills',
    meta: {
      title: '结算账单'
    },
    component: () => import('@/views/roadwork/settlement-bills')
  },
  {
    path: '/decorate/user',
    meta: {
      title: '用户管理'
    },
    component: () => import('@/views/roadwork/User.vue')
  },
  {
    path: '/decorate/workorder/progress',
    meta: {
      title: '工单详细进度'
    },
    component: () => import('@/views/roadwork/workorder-progress.vue')
  },
  {
    path: '/decorate/schedule',
    meta: {
      title: '日程'
    },
    component: () => import('@/views/roadwork/Schedule.vue')
  },
  {
    path: '/decorate/foreman-managment',
    meta: {
      title: '工长管理'
    },
    component: () => import('@/views/roadwork/foreman-managment.vue')
  },
  {
    path: '/decorate/supplier-managment',
    meta: {
      title: '供应商管理'
    },
    component: () => import('@/views/roadwork/supplier-managment.vue')
  },
  {
    path: '/decorate/pre-product',
    meta: {
      title: '商品管理'
    },
    component: () => import('@/views/roadwork/pre-product.vue')
  },
  // {
  //   path: '/roadwork/worker-review',
  //   meta: {
  //     title: '工人入驻审核',
  //   },
  //   component: () => import('@/views/roadwork/worker-review'),
  // },
  {
    path: '/roadwork/worker-management',
    meta: {
      title: '工人管理'
    },
    component: () => import('@/views/roadwork/worker-management.vue')
  },
]
